import { Box } from "@twilio-paste/box";
import { FullScreenCenter } from "./LoadingScreen";
import { Button } from "@twilio-paste/button";

type TwilioErrorScreenProps = {
  onRetry: () => void | Promise<void>;
};

export const TwilioErrorScreen = ({ onRetry }: TwilioErrorScreenProps) => (
  <FullScreenCenter>
    <Box
      as="section"
      padding="space80"
      borderRadius="borderRadius30"
      boxShadow="shadow"
      maxWidth="size60"
      textAlign="center"
    >
      <Box as="h2" marginBottom="space50">
        Si è verificato un problema con il collegamento a Twilio
      </Box>
      <Box marginBottom="space40">
        Prova a rifare l’accesso con il tuo account Microsoft.
      </Box>
      <Button variant="primary" onClick={onRetry}>
        Riprova il login
      </Button>
    </Box>
  </FullScreenCenter>
);
